import React from "react";
import { HiMail } from "react-icons/hi";
import "../css/ContactButton.css";

const ContactButton = () => {
  const email = process.env.REACT_APP_PERSONAL_INFO_EMAIL || "gianesg19@gmail.com";

  return (
    <>
      <a
        href={`mailto:${email}`}
        target="_blank"
        rel="noreferrer"
        className="contact-link"
      >
        <HiMail size={20} />
        <span>Contact me</span>
      </a>
    </>
  );
};

export default ContactButton;
